import { PropsWithChildren, useMemo } from 'react';

import { BaseDialogProps, DialogPropsProvider } from '@shared/context/DialogPropsContext';

import { useSdk } from '../hooks/useSdk';
import { useViewportDimensions } from './ViewportDimensionsContext';

export function SdkDialogPropsProvider({ children }: PropsWithChildren) {
  const sdk = useSdk();
  const { viewportDimensions } = useViewportDimensions();

  const dialogProps: BaseDialogProps = useMemo(() => {
    if (!sdk) {
      return {};
    }

    const borderColor = sdk.colors?.border || 'greys.100';

    return {
      hideBackdrop: true,
      container: document.body,
      sx: viewportDimensions
        ? {
            position: 'fixed' as const,
            top: `${viewportDimensions.height / 2 - viewportDimensions.iframeY}px`,
            left: `${viewportDimensions.iframeWidth / 2}px`,
            transform: 'translate(-50%, -50%)',
            zIndex: 1300,
            width: '100%',
            maxWidth: `${Math.min(viewportDimensions.width, 1200)}px`,
            maxHeight: `${Math.min(viewportDimensions.height * 0.9, 800)}px`,
            '.MuiPaper-root': {
              border: '1px solid',
              borderColor,
            },
          }
        : {},
    };
  }, [sdk, viewportDimensions]);

  return <DialogPropsProvider baseDialogProps={dialogProps}>{children}</DialogPropsProvider>;
}
